/* =========================================================
   AO 1 Point Slam Calendar
   Column order (must match the <thead> in ao-slam-calendar.liquid):
   0 Event Name | 1 Dates | 2 City & State | 3 Surface | 4 Entry Fee | 5 Reg Closing | 6 Status
========================================================= */

let IS_PAGINATION = window.eventSettings?.enablePagination ?? true;
const TOUR_TAG = window.eventSettings?.tourTag || 'AO 1 Point Slam powered by Haier';

let ALL_EVENTS = [];
let CURRENT_STATUS = 'all';
let IS_INITIAL_LOAD = true;
let CURRENT_GENDER = 'all';
let CURRENT_DATE_FROM = null;
let CURRENT_DATE_TO = null;
let CURRENT_ENVIRONMENT = 'all';
let CURRENT_SURFACE = 'all';
let CURRENT_SEARCH = '';
let CURRENT_STATE = 'all';
let CURRENT_PAGE = 1;
const PAGE_SIZE = 11;

document.addEventListener('click', () => {
  document.querySelectorAll('.select-dropdown, .surface-dropdown').forEach((d) => d.classList.remove('show'));
});

/* =========================================================
   GENERIC CUSTOM-SELECT (Gender / Status open-close UI only;
   State is rebuilt dynamically further down with its own handler)
========================================================= */
document.querySelectorAll('.custom-select').forEach((select) => {
  const btn = select.querySelector('.select-btn');
  const dropdown = select.querySelector('.select-dropdown');
  if (!btn || !dropdown) return;

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    document.querySelector('.surface-dropdown')?.classList.remove('show');
    document.querySelectorAll('.select-dropdown').forEach((d) => {
      if (d !== dropdown) d.classList.remove('show');
    });
    dropdown.classList.toggle('show');
  });
});

/* =========================================================
   SURFACE FILTER
========================================================= */
const surfaceBtn = document.querySelector('.surface-btn');
if (surfaceBtn && !surfaceBtn.querySelector('svg')) {
  surfaceBtn.innerHTML = `
    <span class="surface-text">All | All</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M0.134474 4.15884C-0.0330075 4.33829 -0.0429962 4.60822 0.0986352 4.79832L0.158843 4.86553L7.65884 11.8655C7.82693 12.0224 8.07618 12.042 8.26457 11.9244L8.34116 11.8655L15.8412 4.86553C16.043 4.67711 16.0539 4.36072 15.8655 4.15884C15.698 3.9794 15.4294 3.95084 15.23 4.07904L15.1588 4.13447L7.999 10.815L0.841161 4.13447C0.661716 3.96699 0.391787 3.957 0.201687 4.09864L0.134474 4.15884Z" fill="black"/>
    </svg>`;
}

const surfaceDropdown = document.querySelector('.surface-dropdown');
const outdoor = document.getElementById('outdoor');
const indoor = document.getElementById('indoor');
const envAll = document.getElementById('env_all');

surfaceBtn?.addEventListener('click', (e) => {
  e.stopPropagation();
  document.querySelectorAll('.select-dropdown').forEach(d => d.classList.remove('show'));
  surfaceDropdown.classList.toggle('show');
});
surfaceDropdown?.addEventListener('click', (e) => e.stopPropagation());

function updateSurfaceButton() {
  let type = 'All';
  if (CURRENT_ENVIRONMENT === 'outdoor') type = 'Outdoor';
  if (CURRENT_ENVIRONMENT === 'indoor') type = 'Indoor';
  const surface = document.querySelector('.surface-item.active')?.innerText || 'All';
  const textEl = surfaceBtn?.querySelector('.surface-text');
  if (textEl) textEl.innerText = `${type} | ${surface}`;
}

[envAll, outdoor, indoor].forEach(cb => {
  cb?.addEventListener('click', () => {
    if (cb === envAll && envAll.checked) { outdoor.checked = false; indoor.checked = false; CURRENT_ENVIRONMENT = 'all'; }
    if (cb === outdoor && outdoor.checked) { envAll.checked = false; indoor.checked = false; CURRENT_ENVIRONMENT = 'outdoor'; }
    if (cb === indoor && indoor.checked) { envAll.checked = false; outdoor.checked = false; CURRENT_ENVIRONMENT = 'indoor'; }
    if (!envAll.checked && !outdoor.checked && !indoor.checked) { envAll.checked = true; CURRENT_ENVIRONMENT = 'all'; }
    updateSurfaceButton();
    applyFilters(true);
    surfaceDropdown.classList.remove('show');
  });
});

document.querySelectorAll('.surface-item').forEach(item => {
  item.addEventListener('click', () => {
    document.querySelectorAll('.surface-item').forEach(i => i.classList.remove('active'));
    item.classList.add('active');
    CURRENT_SURFACE = item.dataset.value;
    updateSurfaceButton();
    surfaceDropdown.classList.remove('show');
    applyFilters(true);
  });
});
updateSurfaceButton();

/* =========================================================
   DATE PICKER
========================================================= */
const clearBtn = document.getElementById('clear-date');
if (clearBtn) clearBtn.style.display = 'none';

const datePicker = flatpickr('#date_range', {
    mode: 'range',
    dateFormat: 'm/d/Y',

    onChange(selectedDates) {
      if (selectedDates.length !== 2) {
        clearBtn.style.display = 'none';
        return;
      }

      clearBtn.style.display = 'block';

      const from = formatDateMMDDYYYY(selectedDates[0]);
      const to   = formatDateMMDDYYYY(selectedDates[1]);

      CURRENT_DATE_FROM = from;
      CURRENT_DATE_TO   = to;

      fetchInitialEvents(from, to);
      scrollToTop();
    }
  });

clearBtn?.addEventListener('click', async () => {
  datePicker.clear();
  clearBtn.style.display = 'none';
  CURRENT_DATE_FROM = null;
  CURRENT_DATE_TO = null;
  await fetchInitialEvents();
  applyFilters(true);
});

/* =========================================================
   TABLE SORTING (indices match the new column order)
========================================================= */
const table = document.querySelector('.event-table tbody');
let nameAsc = true, dateAsc = true, cityAsc = true, surfaceAsc = true, feeAsc = true, regCloseAsc = true, statusAsc = true;

document.getElementById('sortName')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[0]?.querySelector('.event-title')?.innerText.toLowerCase() || '';
    const B = b.cells[0]?.querySelector('.event-title')?.innerText.toLowerCase() || '';
    return nameAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  nameAsc = !nameAsc;
  table.append(...rows);
});

function sortByDate() {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[1]?.dataset?.start;
    const B = b.cells[1]?.dataset?.start;
    if (!A) return 1;
    if (!B) return -1;
    return dateAsc ? new Date(A) - new Date(B) : new Date(B) - new Date(A);
  });
  dateAsc = !dateAsc;
  table.append(...rows);
}
document.getElementById('sortDate')?.addEventListener('click', sortByDate);

document.getElementById('sortCity')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[2]?.innerText.toLowerCase() || '';
    const B = b.cells[2]?.innerText.toLowerCase() || '';
    return cityAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  cityAsc = !cityAsc;
  table.append(...rows);
});

document.getElementById('sortSurface')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = (a.cells[3]?.dataset?.surface || '').toLowerCase();
    const B = (b.cells[3]?.dataset?.surface || '').toLowerCase();
    return surfaceAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  surfaceAsc = !surfaceAsc;
  table.append(...rows);
});

document.getElementById('sortFee')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = Number(a.cells[4]?.dataset?.feeMin ?? -1);
    const B = Number(b.cells[4]?.dataset?.feeMin ?? -1);
    return feeAsc ? A - B : B - A;
  });
  feeAsc = !feeAsc;
  table.append(...rows);
});

document.getElementById('sortRegClose')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[5]?.dataset?.regclose;
    const B = b.cells[5]?.dataset?.regclose;
    if (!A) return 1;
    if (!B) return -1;
    return regCloseAsc ? new Date(A) - new Date(B) : new Date(B) - new Date(A);
  });
  regCloseAsc = !regCloseAsc;
  table.append(...rows);
});

document.getElementById('sortStatus')?.addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[6]?.innerText.trim().toLowerCase() || '';
    const B = b.cells[6]?.innerText.trim().toLowerCase() || '';
    return statusAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  statusAsc = !statusAsc;
  table.append(...rows);
});

/* =========================================================
   MOBILE FILTER POPUP
========================================================= */
const filterCountEl = document.getElementById('activeFilterCount');
const popupBtn = document.getElementById('popup-modal');
const popup = document.getElementById('filterPopup');
const closePopup = document.getElementById('closeFilterPopup');
const viewBtn = document.getElementById('viewResultsBtn');
const filtersWrapper = document.getElementById('filtersWrapper');
const popupFilters = document.getElementById('popupFilters');
const originalParent = filtersWrapper?.parentNode;
const originalNext = filtersWrapper?.nextSibling;

popupBtn?.addEventListener('click', () => {
  popup?.classList.add('show');
  document.body.style.overflow = 'hidden';
  popupFilters?.appendChild(filtersWrapper);
});

function closePopupFilter() {
  popup?.classList.remove('show');
  document.body.style.overflow = '';
  if (!filtersWrapper || !originalParent) return;
  if (originalNext) originalParent.insertBefore(filtersWrapper, originalNext);
  else originalParent.appendChild(filtersWrapper);
}
closePopup?.addEventListener('click', closePopupFilter);
viewBtn?.addEventListener('click', closePopupFilter);

function updateActiveFilterCount() {
  let count = 0;
  document.querySelectorAll('#filtersWrapper .custom-select').forEach((select) => {
    if (window.getComputedStyle(select).display === 'none') return;
    const value = select.dataset.value || select.querySelector('.select-btn')?.innerText;
    if (value && value.toLowerCase().trim() !== 'all') count++;
  });
  const dateVal = document.getElementById('date_range')?.value;
  if (dateVal) count++;
  const surfaceVal = document.querySelector('#filtersWrapper .surface-btn')?.innerText;
  if (surfaceVal && !surfaceVal.toLowerCase().includes('all')) count++;

  if (filterCountEl) filterCountEl.innerText = count;
  const popupCountEl = document.getElementById('popupActiveFilterCount');
  if (popupCountEl) popupCountEl.innerText = count;
}
document.addEventListener('click', updateActiveFilterCount);
document.addEventListener('change', updateActiveFilterCount);

/* =========================================================
   INITIAL LOAD
========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  fetchInitialEvents();
});

/* =========================================================
   FETCH EVENTS FROM UTR API
   NOTE: field names for entry fee (per division) and registration
   closing date are best-guess based on typical UTR event payload
   shape. Confirm exact field names once the "AO 1 Point Slam" tag
   has live events, and adjust the mapping below if needed.
========================================================= */
async function fetchInitialEvents(from, to) {
  const start = from || getFirstDayOfCurrentMonth();
  const end = to || getEndOfNextYear();

  const API_URL =
    'https://api.utrsports.net/v2/search/events?' +
    // `query=${encodeURIComponent(TOUR_TAG)}` +
    '&top=1000' +
    '&skip=0' +
    '&searchOrigin=searchPage' +
    '&showTennisContent=true' +
    '&showPickleballContent=true' +
    `&tours=${encodeURIComponent(TOUR_TAG)}` +
    `&range=eventSchedule.eventStartUtc>=${start}` +
    `&range=eventSchedule.eventStartUtc<=${end}` +
    `&sort=eventSchedule.eventStartUtc:asc`;

  let data;
  try {
    const res = await fetch(API_URL);
    data = await res.json();
  } catch (err) {
    console.error('AO Slam calendar: failed to fetch events', err);
    ALL_EVENTS = [];
    applyFilters(true);
    return;
  }

  if (!Array.isArray(data.hits)) {
    ALL_EVENTS = [];
    applyFilters(true);
    return;
  }

  ALL_EVENTS = data.hits.map(({ id, source: src }) => {
    const divisions = src.eventDivisions || [];

    // ===== ENTRY FEE =====
    let feeMin = null;
    let feeMax = null;

    const priceText = (src.priceRangeShort || src.priceRange || '').toLowerCase();

    if (priceText.includes('free')) {
      feeMin = 0;
      feeMax = 0;
    } else if (typeof src.flatFee === 'number' && src.flatFee > 0) {
      feeMin = src.flatFee;
      feeMax = src.flatFee;
    } else if (typeof src.entryFee === 'number') {
      feeMin = src.entryFee;
      feeMax = src.entryFee;
    } else {
      const fees = divisions
        .map(d => d.fee ?? d.entryFee ?? d.price)
        .filter(f => typeof f === 'number');
      if (fees.length) {
        feeMin = Math.min(...fees);
        feeMax = Math.max(...fees);
      }
    }

    return {
      id,
      name: src.name,
      start: src.eventSchedule?.eventStartUtc || null,
      end: src.eventSchedule?.eventEndUtc || null,
      regClose: src.eventSchedule?.registrationEndUtc || null,
      city: src.eventLocations?.[0]?.cityName,
      stateName: src.eventLocations?.[0]?.stateAbbr || src.eventLocations?.[0]?.stateName,
      countryCode2: src.eventLocations?.[0]?.countryCode2?.toUpperCase(),
      feeMin,
      feeMax,
      surface: divisions[0]?.surfaces?.[0]?.value || null,
      environment: divisions[0]?.environments?.[0]?.value || null,
      status: src.eventState?.value,
      gender: src.gender,
    };
  });

  buildStateFilter(ALL_EVENTS);
  applyFilters(true);
}

/* =========================================================
   SEARCH
========================================================= */
const searchForm = document.querySelector('.search-form');
const searchInput = document.querySelector('.search-input');

searchForm?.addEventListener('submit', (e) => {
  e.preventDefault();
  CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
  applyFilters(true);
});
searchInput?.addEventListener('input', () => {
  CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
  applyFilters(true);
});

/* =========================================================
   FORMAT HELPERS
========================================================= */
function formatEventDateRangeM(startDate, endDate) {
  if (!startDate || !endDate) return '-';
  const start = new Date(startDate);
  const end = new Date(endDate);
  const fmt = { month: 'short', day: 'numeric' };
  const withYear = (d) => `${d.toLocaleDateString('en-US', fmt)}, '${String(d.getFullYear()).slice(-2)}`;
  if (start.getFullYear() === end.getFullYear()) {
    return `${start.toLocaleDateString('en-US', fmt)} – ${withYear(end)}`;
  }
  return `${withYear(start)} – ${withYear(end)}`;
}

function formatRegClose(regClose) {
  if (!regClose) return '-';
  const d = new Date(regClose);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatFee(feeMin, feeMax) {
  if (feeMin === null || feeMax === null) return '-';
  const label = (v) => (v === 0 ? 'Free' : `$${v}`);
  if (feeMin === feeMax) return label(feeMin);
  return `${label(feeMin)}–${label(feeMax)}`;
}

function formatCityState(city, stateName) {
  const parts = [city, stateName].filter(Boolean);
  return parts.join(', ') || '-';
}

function formatSurface(env, surface) {
  if (!env && !surface) return '-';
  let s = surface;
  if (s && s.toLowerCase() === 'hardcourt') s = 'Hard';
  if (env && s) return `${env} | ${s}`;
  return env || s || '-';
}

function renderStatusBadge(statusValue) {
  const STATUS_MAP = {
    pre_registration: { text: 'Register', class: 'badge-open' },
    open_registration: { text: 'Register', class: 'badge-open' },
    registration_closed: { text: 'Upcoming', class: 'badge-upcoming' },
    in_progress: { text: 'Live', class: 'badge-live' },
    completed: { text: 'Complete', class: 'badge-complete' },
  };
  const status = STATUS_MAP[statusValue];
  if (!status) return `<span class="badge badge-default">${statusValue || '-'}</span>`;
  return `<span class="badge ${status.class}">${status.text}</span>`;
}

function getFirstDayOfCurrentMonth() {
  const d = new Date();
  d.setDate(1);
  return formatDateMMDDYYYY(d);
}
function getEndOfNextYear() {
  const d = new Date(new Date().getFullYear() + 1, 11, 31);
  return formatDateMMDDYYYY(d);
}
function formatDateMMDDYYYY(date) {
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${m}/${d}/${date.getFullYear()}`;
}
function scrollToTop() {
  const section = document.querySelector('.ptt-calendar-table');
  if (!section) return;
  const top = section.getBoundingClientRect().top + window.scrollY - 100;
  window.scrollTo({ top, behavior: 'smooth' });
}

/* =========================================================
   FILTERING
========================================================= */
// function applyFilters(resetPage = false) {
//   if (resetPage) CURRENT_PAGE = 1;

//   const tbody = document.getElementById('eventTableBody');
//   const cardList = document.getElementById('eventCardList');
//   tbody.innerHTML = '';
//   cardList.innerHTML = '';

//   const from = CURRENT_DATE_FROM ? new Date(CURRENT_DATE_FROM + 'T00:00:00') : null;
//   const to = CURRENT_DATE_TO ? new Date(CURRENT_DATE_TO + 'T23:59:59') : null;

//   const filtered = ALL_EVENTS.filter(e => {
//     if (!e.start) return false;
//     const startDate = new Date(e.start);

//     // if (CURRENT_STATUS !== 'all') {
//     //   if (CURRENT_STATUS === 'open_registration') {
//     //     if (e.status !== 'open_registration' && e.status !== 'pre_registration') return false;
//     //   } else if (e.status !== CURRENT_STATUS) {
//     //     return false;
//     //   }
//     // }

//     if (CURRENT_STATUS !== 'all') {
//       if (CURRENT_STATUS === 'open_registration') {
//         if (e.status !== 'open_registration' && e.status !== 'pre_registration') {
//           return false;
//         }
//       } else if (e.status !== CURRENT_STATUS) {
//         return false;
//       }
//     } else {
//       // When Status = All, hide completed events
//       if (e.status === 'completed') return false;
//     }

//     if (from && to) {
//       if (startDate < from || startDate > to) return false;
//     }

//     if (CURRENT_GENDER !== 'all') {
//       const isMixed = CURRENT_GENDER === 'Mixed';
//       if (isMixed) {
//         if (e.gender !== 'Mixed' && e.gender !== 'Co-ed') return false;
//       } else if (e.gender !== CURRENT_GENDER) {
//         return false;
//       }
//     }

//     if (CURRENT_ENVIRONMENT !== 'all') {
//       if (!e.environment || e.environment.toLowerCase() !== CURRENT_ENVIRONMENT) return false;
//     }

//     if (CURRENT_SURFACE !== 'all') {
//       if (!e.surface || !e.surface.toLowerCase().includes(CURRENT_SURFACE)) return false;
//     }

//     if (CURRENT_SEARCH && !e.name?.toLowerCase().includes(CURRENT_SEARCH)) return false;

//     if (CURRENT_STATE !== 'all' && e.stateName !== CURRENT_STATE) return false;

//     return true;
//   });

//   const total = filtered.length;
//   updateResultCount(total);

//   const popupResultCountEl = document.getElementById('popupResultCount');
//   if (popupResultCountEl) popupResultCountEl.innerText = `${total} Results`;

//   if (!total) {
//     tbody.innerHTML = `<tr><td colspan="7">No events</td></tr>`;
//     cardList.innerHTML = `<div class="no-events">No events</div>`;
//     renderPagination(0);
//     return;
//   }

//   if (IS_PAGINATION) {
//     const startIndex = (CURRENT_PAGE - 1) * PAGE_SIZE;
//     const paginated = filtered.slice(startIndex, startIndex + PAGE_SIZE);
//     tbody.innerHTML = paginated.map(renderEventRow).join('');
//     cardList.innerHTML = paginated.map(renderEventCard).join('');
//     renderPagination(total);
//   } else {
//     tbody.innerHTML = filtered.map(renderEventRow).join('');
//     cardList.innerHTML = filtered.map(renderEventCard).join('');
//     renderPagination(0);
//   }
// }

function isEventEndedBeforeToday(endDate) {
  if (!endDate) return false;

  const end = new Date(endDate);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  return end < today;
}

function applyFilters(resetPage = false) {
  if (resetPage) CURRENT_PAGE = 1;

  const tbody = document.getElementById('eventTableBody');
  const cardList = document.getElementById('eventCardList');
  tbody.innerHTML = '';
  cardList.innerHTML = '';

  const from = CURRENT_DATE_FROM ? new Date(CURRENT_DATE_FROM + 'T00:00:00') : null;
  const to = CURRENT_DATE_TO ? new Date(CURRENT_DATE_TO + 'T23:59:59') : null;

  // Kiểm tra xem người dùng có đang áp dụng bất kỳ bộ lọc nào khác ngoài default không
  const hasOtherFilters = 
    CURRENT_GENDER !== 'all' ||
    CURRENT_ENVIRONMENT !== 'all' ||
    CURRENT_SURFACE !== 'all' ||
    CURRENT_SEARCH !== '' ||
    CURRENT_STATE !== 'all' ||
    (from !== null && to !== null);

  const filtered = ALL_EVENTS.filter(e => {
    if (!e.start) return false;
    const startDate = new Date(e.start);

    // Lọc theo Status
    // if (CURRENT_STATUS !== 'all') {
    //   if (CURRENT_STATUS === 'open_registration') {
    //     if (e.status !== 'open_registration' && e.status !== 'pre_registration') {
    //       return false;
    //     }
    //   } else if (e.status !== CURRENT_STATUS) {
    //     return false;
    //   }
    // } else {
    //   // Khi CURRENT_STATUS === 'all':
    //   // Chỉ ẩn 'completed' khi MỚI LOAD PAGE VÀ CHƯA TƯƠNG TÁC LỌC GÌ KHÁC.
    //   // Khi đã chọn các filter khác (hasOtherFilters = true) hoặc không còn là Initial Load, hiển thị cả 'completed'.
    //   if (IS_INITIAL_LOAD && !hasOtherFilters && e.status === 'completed') {
    //     return false;
    //   }
    // }

    if (CURRENT_STATUS !== 'all') {
      if (CURRENT_STATUS === 'open_registration') {
        if (
          e.status !== 'open_registration' &&
          e.status !== 'pre_registration'
        ) {
          return false;
        }
      } else if (e.status !== CURRENT_STATUS) {
        return false;
      }
    } else {
      // Chỉ khi page load ban đầu:
      // - Ẩn Completed
      // - Ẩn event đã kết thúc trước hôm nay
      if (IS_INITIAL_LOAD && !hasOtherFilters) {
        if (e.status === 'completed') {
          return false;
        }

        if (isEventEndedBeforeToday(e.end)) {
          return false;
        }
      }
    }

    if (from && to) {
      if (startDate < from || startDate > to) return false;
    }

    if (CURRENT_GENDER !== 'all') {
      const isMixed = CURRENT_GENDER === 'Mixed';
      if (isMixed) {
        if (e.gender !== 'Mixed' && e.gender !== 'Co-ed') return false;
      } else if (e.gender !== CURRENT_GENDER) {
        return false;
      }
    }

    if (CURRENT_ENVIRONMENT !== 'all') {
      if (!e.environment || e.environment.toLowerCase() !== CURRENT_ENVIRONMENT) return false;
    }

    if (CURRENT_SURFACE !== 'all') {
      if (!e.surface || !e.surface.toLowerCase().includes(CURRENT_SURFACE)) return false;
    }

    if (CURRENT_SEARCH && !e.name?.toLowerCase().includes(CURRENT_SEARCH)) return false;

    if (CURRENT_STATE !== 'all' && e.stateName !== CURRENT_STATE) return false;

    return true;
  });

  const total = filtered.length;
  updateResultCount(total);

  const popupResultCountEl = document.getElementById('popupResultCount');
  if (popupResultCountEl) popupResultCountEl.innerText = `${total} Results`;

  if (!total) {
    tbody.innerHTML = `<tr><td colspan="7">No events</td></tr>`;
    cardList.innerHTML = `<div class="no-events">No events</div>`;
    renderPagination(0);
    return;
  }

  if (IS_PAGINATION) {
    const startIndex = (CURRENT_PAGE - 1) * PAGE_SIZE;
    const paginated = filtered.slice(startIndex, startIndex + PAGE_SIZE);
    tbody.innerHTML = paginated.map(renderEventRow).join('');
    cardList.innerHTML = paginated.map(renderEventCard).join('');
    renderPagination(total);
  } else {
    tbody.innerHTML = filtered.map(renderEventRow).join('');
    cardList.innerHTML = filtered.map(renderEventCard).join('');
    renderPagination(0);
  }
}

function updateResultCount(count) {
  const el = document.getElementById('resultCount');
  if (el) el.innerText = `${count} Result${count !== 1 ? 's' : ''}`;
}

/* =========================================================
   FILTER EVENT BINDINGS
========================================================= */
document.querySelectorAll('.custom-select[data-name="status"] .select-item').forEach((item) => {
  item.addEventListener('click', function () {
    updateSelectUI(this);
    CURRENT_STATUS = this.dataset.value;
    applyFilters(true);
    scrollToTop();
  });
});

document.querySelectorAll('.custom-select[data-name="gender"] .select-item').forEach((item) => {
  item.addEventListener('click', function () {
    updateSelectUI(this);
    CURRENT_GENDER = this.dataset.value;
    applyFilters(true);
    scrollToTop();
  });
});

function updateSelectUI(item) {
  const select = item.closest('.custom-select');
  const btn = select.querySelector('.select-btn');
  select.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
  item.classList.add('active');
  updateSelectButtonText(btn, item.innerText);
  select.dataset.value = item.dataset.value;
}

function updateSelectButtonText(btn, text) {
  if (!btn) return;
  if (btn.firstChild && btn.firstChild.nodeType === Node.TEXT_NODE) {
    btn.firstChild.nodeValue = text + ' ';
  } else {
    btn.insertBefore(document.createTextNode(text + ' '), btn.firstChild);
  }
}

/* =========================================================
   STATE FILTER (built dynamically from event data — fixes the
   bug where selecting a state previously updated CURRENT_COUNTRY)
========================================================= */
function buildStateFilter(events) {
  const select = document.querySelector('.custom-select[data-name="state"]');
  const dropdown = select?.querySelector('.select-dropdown');
  const btn = select?.querySelector('.select-btn');
  if (!dropdown || !btn) return;

  dropdown.innerHTML = '';

  const allItem = document.createElement('div');
  allItem.className = 'select-item active';
  allItem.dataset.value = 'all';
  allItem.innerText = 'All';
  dropdown.appendChild(allItem);

  const states = [...new Set(events.map(e => e.stateName).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  states.forEach(state => {
    const item = document.createElement('div');
    item.className = 'select-item';
    item.dataset.value = state;
    item.innerText = state;
    dropdown.appendChild(item);
  });

  dropdown.querySelectorAll('.select-item').forEach(item => {
    item.addEventListener('click', () => {
      dropdown.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      CURRENT_STATE = item.dataset.value;
      updateSelectButtonText(btn, item.innerText);
      select.dataset.value = CURRENT_STATE;
      applyFilters(true);
      scrollToTop();
    });
  });

  dropdown.addEventListener('wheel', e => e.stopPropagation());
}

/* =========================================================
   PAGINATION
========================================================= */
function renderPagination(total) {
  const totalPages = Math.ceil(total / PAGE_SIZE);
  const el = document.getElementById('pagination');
  if (!el) return;
  if (totalPages <= 1) { el.innerHTML = ''; return; }

  const WINDOW = 5;
  let start = Math.max(1, CURRENT_PAGE - Math.floor(WINDOW / 2));
  let end = start + WINDOW - 1;
  if (end > totalPages) { end = totalPages; start = Math.max(1, end - WINDOW + 1); }

  let html = `<button class="page-btn prev ${CURRENT_PAGE === 1 ? 'disabled' : ''}" ${CURRENT_PAGE === 1 ? 'disabled' : ''}>Prev</button>`;

  if (start > 1) {
    html += `<button class="page-btn" data-page="1">1</button>`;
    if (start > 2) html += `<span class="page-dots">...</span>`;
  }
  for (let i = start; i <= end; i++) {
    html += `<button class="page-btn ${i === CURRENT_PAGE ? 'active' : ''}" data-page="${i}">${i}</button>`;
  }
  if (end < totalPages) {
    if (end < totalPages - 1) html += `<span class="page-dots">...</span>`;
    html += `<button class="page-btn" data-page="${totalPages}">${totalPages}</button>`;
  }
  html += `<button class="page-btn next ${CURRENT_PAGE === totalPages ? 'disabled' : ''}" ${CURRENT_PAGE === totalPages ? 'disabled' : ''}>Next</button>`;

  el.innerHTML = html;

  const eventSection = document.querySelector('.event-table');
  el.querySelectorAll('.page-btn[data-page]').forEach(btn => {
    btn.onclick = () => {
      CURRENT_PAGE = Number(btn.dataset.page);
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  });
  el.querySelector('.prev')?.addEventListener('click', () => {
    if (CURRENT_PAGE > 1) {
      CURRENT_PAGE--;
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  el.querySelector('.next')?.addEventListener('click', () => {
    if (CURRENT_PAGE < totalPages) {
      CURRENT_PAGE++;
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}

if (!IS_PAGINATION) {
  window.addEventListener('scroll', () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.body.offsetHeight - 200;
    if (scrollPosition >= threshold) {
      CURRENT_PAGE++;
      applyFilters(false);
    }
  });
}

/* =========================================================
   RESET FILTERS
========================================================= */
document.querySelectorAll('.resetFilters').forEach(resetBtn => {
  resetBtn.addEventListener('click', async () => {
    CURRENT_STATUS = 'all';
    CURRENT_GENDER = 'all';
    CURRENT_STATE = 'all';
    CURRENT_ENVIRONMENT = 'all';
    CURRENT_SURFACE = 'all';
    CURRENT_SEARCH = '';
    CURRENT_DATE_FROM = null;
    CURRENT_DATE_TO = null;
    CURRENT_PAGE = 1;
    IS_INITIAL_LOAD = true;

    document.querySelectorAll('.custom-select').forEach(select => {
      const btn = select.querySelector('.select-btn');
      const items = select.querySelectorAll('.select-item');
      items.forEach(i => i.classList.remove('active'));
      const allItem = select.querySelector('.select-item[data-value="all"]');
      if (allItem) {
        allItem.classList.add('active');
        updateSelectButtonText(btn, allItem.innerText);
      }
      select.dataset.value = 'all';
    });

    datePicker?.clear();
    if (clearBtn) clearBtn.style.display = 'none';

    if (envAll) envAll.checked = true;
    if (outdoor) outdoor.checked = false;
    if (indoor) indoor.checked = false;
    document.querySelectorAll('.surface-item').forEach(i => i.classList.remove('active'));
    document.querySelector('.surface-item[data-value="all"]')?.classList.add('active');
    updateSurfaceButton();

    if (searchInput) searchInput.value = '';

    updateActiveFilterCount();
    await fetchInitialEvents();
  });
});

/* =========================================================
   RENDER TABLE ROW / CARD
   Column order: Name | Dates | City & State | Surface | Entry Fee | Reg Closing | Status
========================================================= */
function renderEventRow(event) {
  console.log(event);
  return `
    <tr>
      <td>
        <a href="https://app.utrsports.net/events/${event.id}" target="_blank" class="event-title">${event.name || '-'}</a>
      </td>
      <td data-start="${event.start || ''}">${formatEventDateRangeM(event.start, event.end)}</td>
      <td class="city">${formatCityState(event.city, event.stateName)}</td>
      <td data-surface="${event.surface || ''}" style="text-transform:capitalize;display:none">${formatSurface(event.environment, event.surface)}</td>
      <td data-fee-min="${event.feeMin ?? ''}" style="display:none">${formatFee(event.feeMin, event.feeMax)}</td>
      <td data-regclose="${event.regClose || ''}">${formatRegClose(event.regClose)}</td>
      <td>
        <a href="https://app.utrsports.net/events/${event.id}" target="_blank">
          ${renderStatusBadge(event.status)}
        </a>
      </td>
    </tr>
  `;
}

function renderEventCard(event) {
  return `
    <div class="event-card">
      <a class="link-to-event" href="https://app.utrsports.net/events/${event.id}">
        <div class="event-card-title">${event.name || '-'}</div>
        <div class="event-card-date">${formatEventDateRangeM(event.start, event.end)}</div>
        <div class="event-card-row">
          <span>City/State:</span>
          <strong>${formatCityState(event.city, event.stateName)}</strong>
        </div>
        <div class="event-card-row" style="display:none">
          <span>Entry Fee:</span>
          <strong>${formatFee(event.feeMin, event.feeMax)}</strong>
        </div>
        <div class="event-card-row">
          <span>Reg Closing:</span>
          <strong>${formatRegClose(event.regClose)}</strong>
        </div>
        <div class="event-card-bottom">
          <div class="event-card-row" style="display:none">
            <span>Surface:</span>
            <strong>${formatSurface(event.environment, event.surface)}</strong>
          </div>
          <div class="event-card-status">${renderStatusBadge(event.status)}</div>
        </div>
      </a>
    </div>
  `;
}